// Дерево итога операции для компонента с vue-i18n: подписи полей и значений из словаря agent_operations.*, числа и даты —
// по языку интерфейса. Общая обёртка экрана «Ожидают одобрения» и карточки операции в чате Ren (FT-199) над чистым
// effectNode (agentOperationEffect.js): здесь vue-i18n и moment, там — ни того ни другого.
import moment from "moment";
import { momentLocaleFor } from "@/utils/localeInfra";
import { effectNode, effectValueLabel } from "./agentOperationEffect";

export function effectTreeFor(vm, effect) {
  const locale = (vm.$i18n && vm.$i18n.locale) || undefined;
  const localMoment = (value) => moment(value).locale(momentLocaleFor(locale));
  // один форматтер на дерево, а не на каждое число; неверная локаль — числа строкой
  let numberFormat = null;
  try {
    numberFormat = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
  } catch (e) {
    numberFormat = null;
  }
  return effectNode(effect, {
    // подпись поля — из словаря интерфейса; незнакомое поле — именем ключа
    label: (key) => (vm.$te(`agent_operations.fields.${key}`) ? vm.$t(`agent_operations.fields.${key}`) : null),
    // перевод значения (вид платежа, статус, вид таблицы цен, пустой сезон); незнакомое значение — как есть.
    // Сначала словарь места `<родитель>_<ключ>` (blockers_code — код блокера объединения), затем общий по ключу.
    valueLabel: (key, value, parent) =>
      (parent && effectValueLabel(vm.$i18n, `${parent}_${key}`, value)) || effectValueLabel(vm.$i18n, key, value),
    format: {
      number: (n) => (numberFormat ? numberFormat.format(n) : String(n)),
      date: (s) => localMoment(s).format("ll"),
      dateTime: (s) => localMoment(s).format("lll"),
      yes: vm.$t("agent_operations.yes"),
      no: vm.$t("agent_operations.no"),
    },
  });
}
